import React from 'react';
import CreateOrder from '../Orders/CreateOrder';
import AdminRoute from './AdminRoute';

const AdminOrderEdit = () => (
  <AdminRoute>
    <CreateOrder adminEditMode />
  </AdminRoute>
);

export default AdminOrderEdit;
